/**
 * Beräknar vilka kartrutor som behövs för att visa en plats i en ruta av
 * given storlek, med platsen i mitten.
 *
 * Används för den lilla kartbilden på träffkorten. En riktig Leaflet-karta
 * per kort vore alldeles för tungt i en lista; det här är sex bilder som
 * webbläsaren cachar och delar mellan träffar som ligger nära varandra.
 */
const TILE_SIZE = 256;

/** Plats till global bildpunkt vid en viss zoomnivå (Web Mercator). */
export function project(lat, lng, zoom) {
  const scale = TILE_SIZE * 2 ** zoom;
  const latRad = (lat * Math.PI) / 180;

  return {
    x: ((lng + 180) / 360) * scale,
    y: ((1 - Math.log(Math.tan(latRad) + 1 / Math.cos(latRad)) / Math.PI) / 2) * scale,
  };
}

/**
 * Rutorna som täcker en ruta på width × height med platsen centrerad.
 * Varje ruta får sitt läge i pixlar relativt rutans övre vänstra hörn.
 */
export function tilesFor({ lat, lng, zoom = 15, width, height }) {
  const point = project(lat, lng, zoom);
  const originX = point.x - width / 2;
  const originY = point.y - height / 2;

  const maxIndex = 2 ** zoom;
  const firstCol = Math.floor(originX / TILE_SIZE);
  const lastCol = Math.floor((originX + width) / TILE_SIZE);
  const firstRow = Math.floor(originY / TILE_SIZE);
  const lastRow = Math.floor((originY + height) / TILE_SIZE);

  const tiles = [];
  for (let col = firstCol; col <= lastCol; col++) {
    for (let row = firstRow; row <= lastRow; row++) {
      // Utanför kartans kant finns inga rutor att hämta.
      if (row < 0 || row >= maxIndex) continue;

      // Longituden går runt jorden, så kolumnen wrappar.
      const wrappedCol = ((col % maxIndex) + maxIndex) % maxIndex;

      tiles.push({
        key: `${col}-${row}`,
        url: `https://tile.openstreetmap.org/${zoom}/${wrappedCol}/${row}.png`,
        left: col * TILE_SIZE - originX,
        top: row * TILE_SIZE - originY,
      });
    }
  }
  return tiles;
}

export { TILE_SIZE };
